import { listAgentTestUsers } from '@/api/ykt-web/agent'
import { getCourseTreeList } from '@/api/ykt-web/course'
import { getDictionanyByCode } from '@/api/platform/api'
const state = {
  students: [],
  selectArrayIds: [],
  selectArray: [],
  beGoSms: JSON.parse(sessionStorage.getItem('beGoSms')) || [], // 将要短信的人员
  studentList: [],
  courseTreeList: [],
  dictMap: {
    offlineClassStatus: {},
    testType: {},
    timeIfEnough: {},
    testStatusMap: {}
  },
  selectSms: JSON.parse(sessionStorage.getItem('selectSms')) || {
    activeIndex: '',
    sms: {}
  }
}

const mutations = {
  // 初始化数据
  INIT_STUDENT_LIST: (state, list) => {
    state.studentList = list.map(val => ({
      ...val,
      _userTel: val.userTel ? val.userTel.slice(0, 3) + '****' + val.userTel.substr(7) : '',
      courseListActiveIndex: 0,
      activeIndex: 0
    }))
  },
  CLEAR_STUDENT_LIST: (state, list) => {
    state.studentList = []
  },
  beGoSms: (state, list) => {
    state.beGoSms = list
    sessionStorage.setItem('beGoSms', JSON.stringify(list))
  },
  clearBeGoSms: (state) => {
    state.beGoSms = []
  },
  change: (state, payload) => {
    const { item } = payload
    const userId = item.userId
    if (state.selectArrayIds.includes(item.userId)) {
      // 如果项目已经选中，就从selectedItems中移除
      state.selectArrayIds = state.selectArrayIds.filter(id => id !== userId)
    } else {
      // 否则，将项目的ID添加到selectedItems中
      state.selectArrayIds.push(userId)
    }
    state.selectArray = state.students.filter(obj => state.selectArrayIds.includes(obj.userId))
  },
  changeActive: (state, payload) => {
    if (payload.active) {
      state.selectArrayIds = [...new Set([...state.selectArrayIds, ...state.studentList.map(item => item.userId)])]
    } else {
      const ids = state.studentList.map(item => item.userId)
      state.selectArrayIds = [...new Set(state.selectArrayIds.filter(item => !ids.includes(item)))]
    }
    state.selectArray = state.students.filter(obj => state.selectArrayIds.includes(obj.userId))
  },

  initCourseTreeList (state, list) {
    state.courseTreeList = list
  },
  initDictMap (state, dictMap) {
    state.dictMap = dictMap
  },
  selectSms (state, data) {
    state.selectSms = data
    sessionStorage.setItem('selectSms', JSON.stringify(data))
  },
  initSelectSms (state, data) {
    state.selectSms = {
      activeIndex: '',
      sms: {}
    }
    sessionStorage.setItem('selectSms', JSON.stringify({
      activeIndex: '',
      sms: {}
    }))
  }

}

const actions = {
  getStudent ({ commit }, data) {
    return new Promise((resolve) => {
      listAgentTestUsers(data).then(res => {
        commit('initDictMap', res.dictMap)
        commit('INIT_STUDENT_LIST', res.data.list)
        resolve(res)
      })
    })
  },

  getCourseTreeList ({ commit }, data) {
    return new Promise((resolve) => {
      getCourseTreeList({
        parentId: 2,
        isAppValid: 1
      }).then(res => {
        commit('initCourseTreeList', res.data)
        resolve(res.data)
      })
    })
  },

  getStudentAll ({ commit, state }, data) {
    return new Promise((resolve) => {
      listAgentTestUsers(data).then(res => {
        const list = res.data.list.map(val => ({
          ...val,
          activeIndex: 0,
          courseListActiveIndex: 0,
          _userTel: val.userTel ? val.userTel.slice(0, 3) + '****' + val.userTel.substr(7) : ''
        }))
        state.students = list
        resolve(list)
      })
    })
  },

  getDictionanyByCode ({ commit }, pams) {
    return new Promise((resolve) => {
      getDictionanyByCode({ code: pams }).then(res => {
        resolve(res)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
